import { render } from "./EntryPoint.vue?vue&type=template&id=b7dc7376&scoped=true"
import script from "./EntryPoint.vue?vue&type=script&lang=js"
export * from "./EntryPoint.vue?vue&type=script&lang=js"

import "./EntryPoint.vue?vue&type=style&index=0&id=b7dc7376&scoped=true&lang=less"
import "./EntryPoint.vue?vue&type=style&index=1&id=b7dc7376&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7dc7376"]])

export default __exports__